import React from 'react'
import type { RadioInputProps } from './RadioInput'
import { RadioInput } from './RadioInput'

export type RadioInputGroupProps = {
  options: { label: string; value: string }[]
  value: string
} & RadioInputProps

export const RadioInputGroup = ({ options = [], value, name, ...rest }: RadioInputGroupProps) => {
  return (
    <React.Fragment>
      {options.map((m) => {
        const { label } = m
        const optionValue = m.value
        const checked = value === optionValue

        return <RadioInput key={optionValue} name={name} value={optionValue} checked={checked} label={label} {...rest} />
      })}
    </React.Fragment>
  )
}
